import { CHILDREN_AGE_ERROR_MESSAGE, INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE, WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE } from '../constants';
function useTravelerError(_a) {
  var children = _a.children,
    childrenAges = _a.childrenAges,
    lapInfants = _a.lapInfants,
    ageSelectEnabled = _a.ageSelectEnabled,
    isInternationalFlight = _a.isInternationalFlight,
    isWhiteLabel = _a.isWhiteLabel;
  var infantAgeCount = childrenAges ?
  // @ts-ignore
  Object.values(childrenAges).reduce(function (carry, age) {
    return carry + (parseInt(age) === 0);
  }, 0) : 0;
  var infantCount = lapInfants + infantAgeCount;
  var childrenLengthsDoNotMatch = childrenAges && Object.keys(childrenAges).length !== children;
  var hasEmptyChildrenAges = childrenAges && Object.values(childrenAges).findIndex(function (value) {
    return value === '';
  }) !== -1;
  var hasChildrenAgeError = ageSelectEnabled && children > 0 && (childrenLengthsDoNotMatch || hasEmptyChildrenAges);
  var isInternationalFlightLapInfantError = isInternationalFlight && infantCount > 0;
  if (hasChildrenAgeError) {
    return CHILDREN_AGE_ERROR_MESSAGE;
  } else if (isInternationalFlightLapInfantError) {
    return isWhiteLabel ? WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE : INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE;
  }
  return null;
}
export default useTravelerError;